<template>
  <v-toolbar
    app
    flat
  >
    <v-toolbar-side-icon
      class="hidden-md-and-up"
      @click="toggleDrawer"
    />
    <v-container
      mx-auto
      py-0
    >
      <v-layout>
        <a href="/about.html" class="mr-5 hidden-sm-and-down">
          <v-img
            src="/static/assets/logo.png"
            style="cursor: pointer;"
            contain
            height="48"
            width="48"
            max-width="48"
          />
        </a>
        <v-btn
          v-for="(link, i) in links"
          :key="i"
          :href="link.href"
          class="ml-0 hidden-sm-and-down"
          flat
        >
          {{ link.text }}
        </v-btn>
      </v-layout>
    </v-container>
  </v-toolbar>
</template>

<script>
  // Utilities
  import {
    mapGetters,
    mapMutations
  } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['links'])
    },
    methods: {
      ...mapMutations(['toggleDrawer'])
    }
  }
</script>
